import { useEffect, useRef } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesSection from './components/ServicesSection';
import AboutBlock from './components/AboutBlock';
import ProcessSection from './components/ProcessSection';
import WhyChooseUs from './components/WhyChooseUs';
import MapSection from './components/MapSection';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

const useFadeIn = (threshold = 0.06) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('fade-in-visible');
          observer.disconnect();
        }
      },
      { threshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);
  return ref;
};

const FadeSection = ({ children, delay = 0 }: { children: React.ReactNode; delay?: number }) => {
  const ref = useFadeIn();
  return (
    <div
      ref={ref}
      className="fade-in-section"
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </div>
  );
};

const HomePage = () => (
  <main className="w-full min-h-screen bg-[#080604]" style={{ fontFamily: "'Inter', sans-serif" }}>
    <Navbar />
    <HeroSection />
    <TrustBar />
    <FadeSection><ServicesSection /></FadeSection>
    <FadeSection><AboutBlock /></FadeSection>
    <FadeSection><ProcessSection /></FadeSection>
    <FadeSection><WhyChooseUs /></FadeSection>
    <FadeSection><MapSection /></FadeSection>
    <FadeSection><FAQSection /></FadeSection>
    <FinalCTA />
    <Footer />
  </main>
);

export default HomePage;
